module.exports = {

    'OLD_PASSWORD': 'Antigua contraseña',
    'OLD_PASSWORD_REQUIRED': 'Se requiere la antigua contraseña',
    'OLD_PASSWORD_NOT': 'La antigua contraseña no es correcta',
    'NEW_PASSWORD': 'Nueva contraseña',
    'NEW_PASSWORD_REQUIRED': 'Se requiere la nueva contraseña',
    'CONFIRM_PASSWORD': 'Confirmar contraseña',
    'CONFIRM_PASSWORD_REQUIRED': 'Se requiere confirmación dela contraseña',
    'CONFIRM_PASSWORD_SAME': 'Las contraseñas no coinciden',

    // NG-Admin
    'BACK': 'Volver',
    'DELETE': 'Eliminar',
    'CREATE': 'Crear',
    'EDIT': 'Editar',
    'EXPORT' : 'Exportar',
    'ADD_FILTER' : 'Añadir filtro',
    'SEE_RELATED': 'Ver todo relacionado de {{ entityName }}',
    'LIST': 'lista',
    'SHOW': 'Mostrar',
    'SAVE': 'Guardar',
    'N_SELECTED': '{{ length }} Seleccionado',
    'ARE_YOU_SURE': '¿Estás seguro?',
    'YES': 'Si',
    'NO': 'No',
    'FILTER_VALUES': 'Valores de filtro',
    'CLOSE': 'Cerrar',
    'CLEAR': 'Limpiar',
    'CURRENT': 'Corriente',
    'REMOVE': 'Quitar',
    'ADD_NEW': 'Añadir nuevo {{ name }}',
    'BROWSE': 'Busqueda',
    'N_COMPLETE': '{{ progress }}% Completo',
    'CREATE_NEW': 'Crear nuevo',
    'SUBMIT': 'Enviar',
    'SAVE_CHANGES': 'Guardar cambios',
    'BATCH_DELETE_SUCCESS': 'Elementos eliminados correctamente',
    'DELETE_SUCCESS': 'Elemento eliminado correctamente',
    'ERROR_MESSAGE': 'Oops! Ha ocurrido un error(code: {{ status }})',
    'INVALID_FORM': 'Forma invalida',
    'CREATION_SUCCESS': 'Elemento creado correctamente',
    'EDITION_SUCCESS': 'Cambios guardados correctamente',
    'ACTIONS': 'Acciones',
    'PAGINATION': '<strong>{{ begin }}</strong> - <strong>{{ end }}</strong> of <strong>{{ total }}</strong>',
    'NO_PAGINATION': 'Ningún record fue encontrado',
    'PREVIOUS': '« Anterior',
    'NEXT': 'Siguiente »',
    'DETAIL': 'Detalle',
    'STATE_CHANGE_ERROR': 'Error de cambio de estado: {{ message }}',
    'NOT_FOUND': 'No funciona',
    'NOT_FOUND_DETAILS': 'La página que busca no se encuentra. Tome un descanso antes de intentarlo de nuevo.',

    //lang
    'SPANISH' : "Castellano",
    'ENGLISH' : "Inglés",
    'CATALAN' : "Catalán",

    //Menu
    'ORDERS' : "Ordenes",
    'ACCOUNT' : "Cuenta",
    'PURCHASES' : "Compras",
    'DOWNLOADS' : "Descargas",
    'USERS' : "Usuarios",
    'USER_LIST' : "Lista de pacientes",
    'PRENSCRIBER_LIST' : "Lista de profesionales",
    'COMPANY_LIST' : "Lista de empresas",
    'PRESCRIBER_TYPES' : "Tipos de prescriptor",
    'PRODUCTS' : "Productos",
    'SUBSCRIPTIONS': "Suscripciones",
    'LICENCES': "Licencias",
    'LICENCES_TEXT': 'Todas las licencias están sujetas a un mantenimiento anual y la firma de un contrato',
    'GAMES': "Juegos",
    'CONFIG': "Configuración",
    'VARIABLES': "Variables",
    'ABILITIES': "Habilidades",
    'LOGOUT': "Cerrar sesión",
    'PRESNCRIPTORS': 'Prescriptores',
    'PROFESSIONAL_MANUAL': 'Manual del profesional',
    'PROFESSIONAL_MANUAL_LINK': 'https://s3.eu-west-2.amazonaws.com/s3-brainvt-web/documents/manual_profesional_cast.pdf',
    'USER_MANUAL': 'Guia de usuario',
    'USER_MANUAL_LINK': 'https://s3.eu-west-2.amazonaws.com/s3-brainvt-web/documents/guia_usuario_cast.pdf',
    'VIDEOS_TUTORIAL': 'Videos tutoriales',
    // Login
    'REGISTER': "Registro",
    'LOGIN': "Iniciar sesión",
    'USERNAME_OR_EMAIL': "Nombre de usuario",
    'RECOVERY_PASSWORD': "Recuperar contraseña",
    'USERNAME_EMAIL_RECOVERY': "Se requiere un nombre de usuario.",
    'PASSWORD_REQUIRED': "Se requiere contraseña.",
    'LETS_GO': "¡Vamos!",
    'PASSWORD': "Contraseña",
    'ERROR_USSER_PASSWORD_INCORRECT': "Nombre de usuario o contraseña incorrecta",
    'LOGIN_REGISTER': "Regístrate",
    'OR': "o",
    'ERROR_LINK_EXPIRED': 'El link para recuperar contraseña ha expirado, por favor solicite otros',

    //Recovery
    'SIGN_IN_AGAIN': "Iniciar sesión de nuevo",
    'INTERNAL_ERROR': "Error interno",
    'Invalid username or email': "Nombre de usuario no válido",
    'Password request alerady requested': "Solicitud de contraseña ya ha sido solicitada",
    'SEND_EMAIL_REQUEST_SUCCESS': "Te hemos enviado un email con los pasos para restablecer la contraseña.",


    //Register
    'USER': "Usuario",
    'USERNAME': "Nombre de usuario",
    'USERNAME_REASON': 'El nombre de usuario se usará para que te podamos identificar en la pantalla de login',
    'PRESCRIBER': "Prescriptor",
    'USERNAME_REQUIRED': "Se requiere nombre de usuario",
    'ACCEPT_TERMS_SERVICE': "Acepto los términos del servicio",
    'YOU_MUST_ACCEPT_TERMS_SERVICE_BEFORE_PROCEED': "Debe aceptar los términos de servicio antes de continuar",
    'USERNAME_ALREADY_TAKEN': "El nombre de usuario ya esta usado",
    'CREATED_CHECK_YOUR_EMAIL': 'Su cuenta se ha creado correctamente, verifique su correo electrónico.',
    'MALFORMET_DATA': 'Se ha producido errores en el formulario',
    'PASSWORD_SHORT': 'La contraseña es demasiado corta',

    //Account
    'YOU_ARE': "Tipo de usuario",
    'YOUR_LICENCES': "Tus licencias",
    'MANAGE_LICENCES': "Administrar licencias",
    'YOUR_SUBSCRIPTIONS': "Tus suscripciones",
    'NEED_MORE_LICENCES': "¿Necesita más licencias?",
    'PURCHASE_LICENCES': "Licencias de compra",
    'PURCHASE_SUBSCRIPTIONS': "Comprar Subscripciones",
    'ADD_LICENCE': "Agregar licencia",
    'RECHARGE_SUBSCRIPTIONS': "Suscripciones de recarga",
    'ACTIVE_UNUSED': "Activo / no utilizado",
    'MANAGE_SUSCRIPTIONS': "Administrar Suscripciones",
    'ADD_SUSCRIPTIONS': "Añadir suscripciones",
    'ORDERS_INVOICES': "Pedidos y facturas",
    'YOUR_LAST_PAYMENT': "Su último pago, de",
    'WAS_MADE_ON': "Fue hecho en",
    'SHOW_ORDERS': "Mostrar pedidos y facuturas",
    'Company' : 'Empresa',
    'Prescriber' : 'Prescriptor',
    'Patient' : 'Paciente',

    //calendary
    'january': "enero",
    'february': "febrero",
    'march': "marzo",
    'april': "abril",
    'mayo': "mayo",
    'june': "junio",
    'july': "julio",
    'august': "agosto",
    'september': "septiembre",
    'october': "octubre",
    'november': "noviembre",
    'december': "diciembre",

    //Licences
    'LICENCE': "Liciencia",
    'ASSIGNED_TO': "Asignado a",
    'EXPIRATION_AT': "Expira el",
    'MAC': "Mac",
    'REASSIGN_THIS_LICENCE': "Reasignar esta licencia",
    'CHOOSE_AN_USER': "Elige un usuario",
    'SELECT_AN_USER': "Seleccione un usuario",
    'REVOKE_MAC_LICENCE': "Revocar esta licencia de Mac",
    'REASSIGN': "Reasignar",
    'REMOVE_YOUR_LICENCE_LINK': "¿Desea eliminar su enlace de licencia?",
    'REMOVE_YOUR_LICENCE_LINK_TEXT': "Al eliminar el enlace de licencia, puede utilizar esta licencia en otro equipo. <br>' + 'Tenga en cuenta que el nuevo equipo estará vinculado a esta licencia",
    'LUCKY_DAY': "Feliz dia",
    'SUCCESS_REMOVE_LICENCE': "Su enlace de licencia se ha eliminado.",
    'MANUAL_INVOICE': 'Factura manual',
    'NO_LICENCE': 'Necesita una licencia activa',
    'NO_LICENCE_BUY': 'Por favor compre una licencia',

    //Purchases
    'SELECT_PRODUCT': "Seleccionar producto",
    'PROMOTIONAL_CODE': "¿Tiene un código promocional?",
    'CODE_DOES_NOT_PROMOTION': "El código no tiene ninguna promoción",
    'TOTAL_ITEMS': "Articulos totales",
    'TAXES': "Impuestos",
    'AMOUNT_PAYABLE': "Total a pagar",
    'USE_MY_ACCOUNT_INFORMATION_INVOICE': "Usar la información de mi cuenta para la factura",
    'USE_OTHER_INFORMATION_INVOICE': "Usar otra información para la factura",
    'NAME': "Nombre",
    'NAME_REQUIRED': "Se requiere el nombre",
    'SURNAME': "Apellido",
    'SURNAME_REQUIRED': "El apellido es requerido",
    'COMPANY': "Empresa",
    'CIF/NIF': "CIF/NIF",
    'CIF_NIF_REQUIRED': "CIF o NIF es requerido",
    'ADDRESS': "Dirección",
    'CITY': "Ciudad",
    'STATE': "Provincia",
    'COUNTRY': "País",
    'COMPANY_REQUIRED': "La empresa es requerida",
    'POSTAL_CODE': "Código Postal",
    'YOU_SUPPLY_POSTAL_CODE': "Debe proporcionar un código postal",
    'THAT_DOESNT_LOOK_LIKE_VALID_PC': "Eso no parece un código postal válido",
    'BUY_LICENCE': "Comprar",
    'BUY_SUSCRIPTIONS': "Comprar",
    'ORDER': "Orden",
    'YOU_MUST_MAKE_BANK_TRANSFER': "Debe hacer una transferencia bancaria a",
    'WITH_THE_CONCEPT': "Con el concepto",
    'PAY_WITH_PAYPAL': "Pagar con PayPal",
    'PAY_WITH_CREDIT_CARD': "Pagar con tarjeta de crédito",
    'PAY_WITH_WIRE_TRANSFER': "Pagar con transferencia bancaria",
    'SELECT_METHOD': "Seleccione un método",
    'YOU_DONT_HAVE_PERMISSION_AREA': "No tienes permiso en esta área",
    'UNIT_PRICE': "La unidad sale a",
    'YOUR_PENDING_REMOVED':"Se ha eliminado la compra pendiente",
    'CONFIRM_REMOVE_PURCHASE_PENDING':"¿Desea eliminar esta compra pendiente?",
    'CANCEL':"Cancelar",
    'REMOVE!':"Eliminar!",
    'BUY_SUCCESS': "Su pedido ha sido tramitado correctamente.",
    'CIF_NIF_ALREADY_EXISTS': "El cif/nif/nie ya existe",
    'CIF_NIF_INVALID' : "El cif/nif/nie es invalido",
    'PHONE_REQUIRED': "El telefono es requerido",
    'ADDRESS_REQUIRED': "La dirección es requerida",
    'CITY_REQUIRED': "La ciudad s requedia",

    //ERRORS
    'PLEASE_INSERT_NUMERIC_VAL':"¡Porfavor inserte un valor numérico!",
    'NOT_ENOUGH_SUBS':"No tienes suficientes suscripciones",
    'USER_HAS_NOT_SUBS':"Este usuario no tiene suscripción",
    'UNAUTORITHED':"Sin autorización",
    'INVALID_DETAILS_IN_FORM':"Algunos valores no son válidos, ver detalles en el formulario",

    //thanks
    'THANK_YOU': "Gracias",
    'THE_PURCHASE_WAS_MADE_CORRECTLY': "La compra se realizó correctamente, puede administrar sus compras en la sección de su cuenta",

    //Profile
    'PROFILE': "Perfil",
    'EMAIL': "Email",
    'EMAIL_REQUIRED': "El email es requerido",
    'EMAIL_NOT_VALID': "El Email no es válido",
    'EMAIL_ALREADY_TAKEN': "El Email ya aceptado o no válido",
    'BIRTHDAY': "Fecha de nacimiento",
    'MATURATIVE_AGE': 'Edad madurativa',
    'BIRTHDAY_REQUIRED': "El cumpleaños es requerido",
    'PRESCRIBER_TYPE': "Tipo de prescriptor",
    'PRESCRIBER_TYPE_REQUIRED': "Se requiere el tipo de prescripción",
    'UPDATE_MY_DATA': "Actualizar mis datos",
    'CHANGE_PASSWORD': "Cambiar contraseña",
    'PROFILE_UPDATE': "Tu perfil ha sido actualizado",

    //Subscriptions
    'MANAGE_SUBSCRIPTIONS': "Administrar Suscripciones",
    'PRESCRIPTOR': "Prescriptor",
    'PATIENT': "Paciente",
    'PATIEN_EMAIL': "Paciente Email",
    'STATUS': "Estado",
    'NUM_SUBSCRIPTIONS': "Número de suscripciones",
    'EXPIRATE_AT': "Expira en",
    'LINK_SUBSCRIPTION': "Vincular una nueva suscripción",
    'UNLINK_SUBSCRIPTION': "Desvincular esta suscripción",
    'ADD_SUBSCRIPTION': "Añadir más suscripciones",
    'NO_SERS_YET': "No hay usuarios todavía",
    'WOULD_LIKE_ADD_NEW_USER': "¿Quieres añadir un nuevo usuario?",
    'active': 'Activo',
    'inactive': 'Inactivo',
    'MODAL_CANCEL' : 'Cancelar',
    'ADD_SUBSCRIPTION_TITLE' : '¿Cuántos meses de suscripción quiere agregar?',
    'ADD_SUBSCRIPTION_CONTENT' : "Cada unidad de suscripción es equivalente a 1 mes. <br> Si desea que un usuario tenga 3 meses de suscripción, agregue 3. <br> Nota: cada unidad consume un suscriptor del total.",
    'ADD_SUBSCRIPTION_INPUT' : 'Numero de suscripciónes',
    'ADD_SUBSCRIPTION_SUCCESS' : "La suscripción se ha agregado correctamente.",
    'ADD_SUBSCRIPTION_BUTTON' : 'Añadir suscripción!',
    'REMOVE_SUBSCRIPTION_TITLE' : '¿Seguro que desea eliminar esta subscrición a este usuario?',
    'REMOVE_SUBSCRIPTION_CONTENT' : 'Al eliminar la suscripción, el usuario ya no tendrá acceso.',
    'REMOVE_SUBSCRIPTION_BUTTON' : 'Eliminar!',
    'REMOVE_SUBSCRIPTION_SUCCESS' : "La suscripción se ha eliminado correctamente",
    'NO_USERS_YET' : "No tiene usuarios",
    'ENOUGH_SUBSCRIPTION_TITLE': 'No tienes suficientes suscripciones',
    'ENOUGH_SUBSCRIPTION': 'No tiene más suscripciones para asignar. <br> Compra más o notifica a tu administrador',
    'OK': 'Vale',
    'LAST_ASSINGED': 'Última asignación',

    //Invoices
    'INVOICES': "Facturas",
    'PRODUCT': "Producto",
    'AMOUNT': "Cantidad",
    'DATE': "Fecha",
    'DOWNLOAD_INVOICE': "Descargar factura",
    'NO_PURCHASE_YET': "No hay compra todavía",
    'PENDING_ORDERS': "Ordenes pendientes",
    'MAKE_PAYMENT_NOW': "Realizar el pago ahora",
    'REMOVE_PENDING_ORDER': "Eliminar esta orden pendiente",
    'PAYMENTS': 'Abonos',
    'PAYMENT': 'Abono',

    //summary
    'MONTHLY_REVENUE': "Ganancia Mensual",
    'VIEW_DETAILS': "Ver detalles",
    'PENDING_REVIEWS': "Reseñas pendientes",
    'NEW_CUSTOMERS': "Nuevos clientes",

    //Products
    'ABBR': "Abbr",
    'PRICE': "Precio",
    'PRICE_MONTH': "Precio total",
    'ENROLLMENT': "Matrícula",
    'PROMOTIONAL': "Promocional",
    'TYPE': "Tipo",
    'UNITS': "Unidades",
    'GAME': "Juego",

    //Variables
    'ABBREVIATION': "Abreviatura",
    'DESCRIPTION': "Descripción",
    'FLOAT': "Float",
    'INTEGER': "Integer",
    'BOOLEAN': "Boolean",
    'MULTIPLE': "Multiple",
    'REPETITIONS': "Repetitions",
    'MODIFY_FIXED': "Modificar fijo",
    'MODIFY_RELATION': "Modificar Relación",
    'HARDNESS_INITIAL': "Dureza Inicial",
    'MODIFY_VARIABLE': "Modificar la variable",
    'STEPS': "Pasos",
    'KEY': "Llave",
    'VALUE': "Valor",

    //Game
    'WEIGHT': "Peso",
    'ABILITY': "Habilidad",
    'PERCENTAGE': "Porcentaje",
    'ADD': "Añadir",
    'VARIABLE': "Variable",
    'INCLUDED' : "Incluido",
    'ONLY_GOLD': 'Solo visible en PRO GOLD',
    'VISIBLE_AUTOMATIC':'NO visible en terapia automática',

    //Entities
    'ID': "Id",
    'FINALIZED': "Finalizado",
    'IDENTIFIER': "Identificador",
    'IP': "Ip",
    'METHOD': "Método",
    'UPDATED': "Actualizado",
    'PAYPAL': "PayPal",
    'CREDIT_CARD': "Tarjeta de Crédito",
    'WIRE_TRANSFER': "Transferencia Bancaria",
    'SUBSCRIPTION': "Suscripción",
    'CODE': "Código",

    //User
    'user': "usuario",
    'Users': "Usuarios",
    'ENABLED': "Habilitado",
    'CREATED': "Creado",
    'ROLES': "Roles",
    'WORKERS': "Trabajadores",
    'PATIENTS': "Pacientes",
    'CIF': "Cif",
    'TRAINING_TIME_MIN': "Tiempo de entrenamiento (min)",
    'TRAINING_TIME': "Tiempo de entrenamiento",
    'TRAINING_DATE': "Fecha de entrenamiento",
    'USER_TEST': "Usuario Test",

    //Download
    'DOWNLOAD' : 'Descargar',
    'TEXT_DOWNLOAD' : 'Descarga aquí tu gestor de aplicaciones',
    'USER_VISUAL_WINDOWS': 'https://s3-brainvt-app.s3.eu-west-2.amazonaws.com/manuals/user_visual_guide_windows_es.pdf',
    'USER_VISUAL_ANDROID': 'https://s3-brainvt-app.s3.eu-west-2.amazonaws.com/manuals/user_visual_guide_android_es.pdf',
    'INSTALL_WINDOWS': 'https://s3-brainvt-app.s3.eu-west-2.amazonaws.com/manuals/sport_install_guide_windows_es.pdf',
    'INSTALL_ANDROID': 'https://s3-brainvt-app.s3.eu-west-2.amazonaws.com/manuals/sport_install_guide_windows_es.pdf',
    'USER_GUIDE_LABEL': 'Guía Visual',
    'INSTALL_LABEL': 'Guía Instalación',

    //Licences VR
    'LICENCES_GAME_VR' : 'Licencias GAME VR',

    //Events
    'EVENTS': 'Eventos',
    'LOCATION': 'Localización',
    'LOCATION_MAP': 'Localización en mapa google',
    'INTERESTED': 'Interesados',
    'IMAGE': 'Imagen',
    'PHONE': 'Teléfono',

    //ORDERS
    'purchase': "compra",
    'User': "Usuario",
    'Product': "Producto",
    'Status': "Estado",
    'Status Code': "Código de estado",
    'Method': "Método",

    //Promo
    'PROMO_UNAVAIABLE': 'La prueba gratuita ya a sido usada',
    'PROMO_REQUEST': 'Solicita tu prueba gratuita',
    'PROMO_REGISTER' : 'Registro para prueba gratuita',
    'PROMO_CREATED_CHECK_YOUR_EMAIL' : 'Le hemos enviado los pasos a seguir por email.',
    'PROMO_PROBLEM_TITLE': "Se produjo un error",
    'PROMO_PROBLEM_TEXT': "Se han detectado errores y no puede continuar con el registro para la prueba gratuita, <br>por favor envíe un correo electrónico a <a href=\"mailto:info@brainvt.com?Subject=Error para prueba gratuita\">info@brainvt.com</a> o llamando al 619 871 407",

    //Purchase Licence
    'BILLED_YEARLY': 'Facturado anualmente',
    'YEAR_SAVE': 'Ahorras',
    'MOTNH': 'Mes',
    'SELECT': 'Seleccionar',
    'YEAR': 'Año',
    'BILLED_MONTHLY': 'Facturado mensualmente',

    //Paypal status
    'SHOW_INVOICES': 'Ver facturas',
    'PAY_STATE': 'Estado',
    'CANCEL_SUBSCRIPTION': 'Cancelar subscripción',
    'REFRESH_SUBSCRIPTION': 'Iniciar subscripción',
    'recurring_payment_profile_created' : 'Pendiente',
    'recurring_payment_profile_created_help' : 'La subscripción a la licencia se ha iniciado pero aun no se ha aprobado',
    'recurring_payment': 'Completado',
    'recurring_payment_help' : 'La subsripción a la licencia se ha completado con exito',
    'recurring_payment_profile_cancel' : 'Cancelado',
    'recurring_payment_profile_cancel_help' : 'La subsripción a la licencia se ha cancelado, puede volver a activarla usando el icono del carrito',
    'recurring_payment_expired': 'Expirado',
    'recurring_payment_expired_help': 'La subscripción a la licencia ha expirado, puede volver a activarla usando el icono del carrito',
    'recurring_payment_suspended': 'Suspendido',
    'recurring_payment_suspended_help': 'La subscripción a la licencia se ha suspendido, puede volver a activarla usando el icono del carrito',
    'recurring_payment_default': 'Fallido',
    'recurring_payment_default_help': 'La subscripción a la licencia ha fallado, pongase en contacto con el equipo de BrainVTEduca'

};


/** WEBPACK FOOTER **
 ** ./js/languages/es.js
 **/